// extracted by mini-css-extract-plugin
export default {"root":"_2tv5g"};